// pages/components/billing/ConfirmationStatusModal.jsx
import React, { useState } from 'react';
import { Check, Sparkles, Zap, Crown, ArrowRight, Loader2, AlertCircle, CheckCircle, X } from 'lucide-react';

 
const ConfirmationStatusModal = ({ confirmUpgrade, modalData, setShowModal}) => {

return (
<div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4 backdrop-blur-md">
<div className="bg-white rounded-2xl max-w-md w-full p-6 shadow-2xl">
{modalData.type === 'confirm' && (
<>
<div className="flex items-center gap-3 mb-4">
<div className={`p-3 rounded-xl ${
modalData.isUpgrade ? 'bg-green-100' : 'bg-blue-100'
}`}>
{modalData.isUpgrade ? (
<ArrowRight className="text-green-600" size={24} />
) : (
<ArrowRight className="text-blue-600 rotate-180" size={24} />
)}
</div>
<div>
<h3 className="text-xl font-bold text-slate-900">
Confirm {modalData.isUpgrade ? 'Upgrade' : 'Downgrade'}
</h3>
</div>
</div>

<p className="text-slate-700 mb-4">
You're about to {modalData.action} <strong>{modalData.packageName}</strong> package.
</p>

<div className="bg-slate-50 rounded-lg p-4 mb-6">
<div className="flex justify-between items-center">
<span className="text-slate-600">Package Price:</span>
<span className="text-2xl font-bold text-slate-900">${modalData.price}</span>
</div>
<p className="text-xs text-slate-500 mt-2">
{modalData.isUpgrade 
? '* Pro-rated credit will be applied at checkout'
: '* Full payment for new package cycle'
}
</p>
</div>

<div className="flex gap-3">
<button
onClick={() => setShowModal(false)}
className="flex-1 px-4 py-3 bg-slate-200 hover:bg-slate-300 text-slate-700 font-semibold rounded-lg transition-all"
>
Cancel
</button>
<button
onClick={confirmUpgrade}
className="flex-1 px-4 py-3 bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 text-white font-semibold rounded-lg transition-all"
>
Proceed to Payment
</button>
</div>
</>
)}

{modalData.type === 'success' && (
<>
<div className="text-center mb-4">
<div className="inline-flex p-4 bg-green-100 rounded-full mb-3">
<CheckCircle className="text-green-600" size={48} />
</div>
<h3 className="text-xl font-bold text-slate-900 mb-2">Success!</h3>
<p className="text-slate-600">{modalData.message}</p>
</div>
</>
)}

{modalData.type === 'error' && (
<>
<div className="text-center mb-4">
<div className="inline-flex p-4 bg-red-100 rounded-full mb-3">
<AlertCircle className="text-red-600" size={48} />
</div>
<h3 className="text-xl font-bold text-slate-900 mb-2">Error</h3>
<p className="text-slate-600">{modalData.message}</p>
</div>
<button
onClick={() => setShowModal(false)}
className="w-full px-4 py-3 bg-slate-200 hover:bg-slate-300 text-slate-700 font-semibold rounded-lg transition-all"
>
Close
</button>
</>
)}
</div>
</div>
);
};

export default ConfirmationStatusModal;